const STRICT_THREE_PART_SEMVER = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)$/;

export function extractVersionFromFilename(filename) {
  const match = filename.match(/\d+\.\d+\.\d+/);
  const version = match?.[0];

  if (!version || !STRICT_THREE_PART_SEMVER.test(version)) {
    throw new Error('Filename must contain a strict three-part version (for example, 0.1.145).');
  }

  return version;
}

export function platformFromFilename(filename) {
  const normalizedFilename = filename.toLowerCase();

  if (normalizedFilename.endsWith('.msi')) {
    return 'windows';
  }

  if (normalizedFilename.endsWith('.appimage')) {
    return 'linux';
  }

  throw new Error('Installer must be an .msi or .AppImage file.');
}

export function mergeInstallersForVersion(existingRelease, version, platform, installer) {
  const existingInstallers = existingRelease?.version === version
    ? existingRelease.installers || {}
    : {};

  return {
    ...existingInstallers,
    [platform]: installer,
  };
}

export function bytesToHex(bytes) {
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
}

export async function sha256File(file) {
  const fileBuffer = await file.arrayBuffer();
  const digest = await crypto.subtle.digest('SHA-256', fileBuffer);
  return bytesToHex(new Uint8Array(digest));
}
